import { create } from 'zustand';

const useFormStore = create(set => ({
  // Form values stored by lexicon key
  values: {},

  // Customer details
  customerDetails: {},

  // Quote details
  quoteDetails: {},

  // Current panel index
  currentPanelIndex: 0,

  // Actions
  setValue: (lexicon, value) =>
    set(state => ({
      values: {
        ...state.values,
        [lexicon]: value,
      },
    })),

  setValues: values =>
    set(state => ({
      values: {
        ...state.values,
        ...values,
      },
    })),

  setCustomerDetails: customerDetails => set({ customerDetails }),

  updateCustomerDetails: updates =>
    set(state => ({
      customerDetails: {
        ...state.customerDetails,
        ...updates,
      },
    })),

  setQuoteDetails: quoteDetails => set({ quoteDetails }),

  updateQuoteDetails: updates =>
    set(state => ({
      quoteDetails: {
        ...state.quoteDetails,
        ...updates,
      },
    })),

  setCurrentPanelIndex: index => set({ currentPanelIndex: index }),

  resetForm: () =>
    set({
      values: {},
      customerDetails: {},
      quoteDetails: {},
      currentPanelIndex: 0,
    }),

  // Get value by lexicon
  getValue: lexicon => {
    const state = useFormStore.getState();
    return state.values[lexicon] ?? '';
  },
}));

export default useFormStore;
